import Card from "antd/es/card/Card";
import ProductRanges from "entities/ProductRanges";
import { get, isEmpty } from "lodash";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdOutlineSell } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { user } = useContext(StoreContext);
  const organizationId = get(user, "organization.id");
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRODUCT_RANGE);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState("");
  const filter = {
    ...INITIAL_VALUES,
    orderBy: [{ code: "ASC" }],
    like: isEmpty(search)
      ? undefined
      : {
          OR: [{ label: `%${search}%` }, { code: `%${search}%` }],
        },
  };
  const navigate = useNavigate();

  const buttons = [
    ...(organizationId
      ? [
          {
            icon: <MdOutlineSell size={24} />,
            text: LIST.HEADER.SELLER_CODES,
            type: "primary--outlined",
            onClick: () =>
              navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.SELLER_CODES.path),
          },
        ]
      : []),
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.CREATE.path, {
          state: { ...filter, ...pagination },
        }),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <ProductRanges
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
    </>
  );
};

export default List;
